function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Trash/M/Default"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21,6 L16,6 L16,4.33 C15.951155,2.99710005 14.8330357,1.95501294 13.5,2 L10.5,2 C9.16696427,1.95501294 8.04884504,2.99710005 8,4.33 L8,6 L3,6 C2.44771525,6 2,6.44771525 2,7 C2,7.55228475 2.44771525,8 3,8 L4,8 L4,19 C4,20.6568542 5.34314575,22 7,22 L17,22 C18.6568542,22 20,20.6568542 20,19 L20,8 L21,8 C21.5522847,8 22,7.55228475 22,7 C22,6.44771525 21.5522847,6 21,6 Z M10,4.33 C10,4.17 10.21,4 10.5,4 L13.5,4 C13.79,4 14,4.17 14,4.33 L14,6 L10,6 L10,4.33 Z M18,19 C18,19.5522847 17.5522847,20 17,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,8 L18,8 L18,19 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,17 C9.55228475,17 10,16.5522847 10,16 L10,12 C10,11.4477153 9.55228475,11 9,11 C8.44771525,11 8,11.4477153 8,12 L8,16 C8,16.5522847 8.44771525,17 9,17 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,17 C15.5522847,17 16,16.5522847 16,16 L16,12 C16,11.4477153 15.5522847,11 15,11 C14.4477153,11 14,11.4477153 14,12 L14,16 C14,16.5522847 14.4477153,17 15,17 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}));

function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.636d0c56.svg";
export { ForwardRef as ReactComponent };